import { unescape } from 'lodash'
import { AppError } from '../logger'
import { appContext } from '../viewer-app-module/DataBindingAppContext'

export const convertOldComponentToNew = (component) => {
  const newComponent = {
    setData: (data) => {
      const { connectionConfig: { properties = {} } } = component
      const propsWithNesting = []

      for (const prop of Object.keys(properties)) {
        if (prop.includes('.')) {
          const parentProps = prop.split('.').slice(0, -1)
          for (const parentProp of parentProps) {
            if (!propsWithNesting.includes(parentProp)) {
              propsWithNesting.push(parentProp)
            }
          }
        }
      }

      setDataToComponent(component, data, propsWithNesting)
    },
    bind: () => { },
    execute: () => { },
    id: component.uniqueId, //TODO: review
  }
  return newComponent
}

const setDataToComponent = (component, data, propsWithNesting) => {
  for (const [prop, value] of Object.entries(data)) {
    if (propsWithNesting.includes(prop)) {
      setDataToComponent(component[prop], value, propsWithNesting)
    } else if (prop === '_hack_link') { // $link is created by the connection adapter exactly for this hack
      putLinkToTheDeepestChild(component, value)
    } else {
      try {
        component[prop] = value
      } catch (error) {
        //TODO:Migration:Phase1: what should we log here? Where is tested
        appContext.logger.log(
          new AppError(`CVCI - setDataToComponent failed - id: ${component.uniqueId}, role: ${component.role}, prop: ${prop}`, {
            cause: error,
          }),
        )
      }
    }
  }
}

const putLinkToTheDeepestChild = (component, link) => {
  component.text = link
  const { html } = component
  component.text = ''
  component.html = unescape(html)
}
